const DOC = document;

export default function (className) {

	const CORE = {

		elements: null,

		__onElements: function (callback) {
			const elements = CORE.elements;
			var i = 0;

			if (elements == null || typeof callback !== 'function') {
				return;
			}

			for (i; i < elements.length; i++) {
				callback(elements[i]);

			}

		},

		getElements: function () {

			return CORE.elements;

		},

		append: function (content) {

			if (typeof content === 'object' && content !== null) {
				CORE.__onElements(function (el) {
					el.appendChild(content);
				});
				return;
			}

			if (typeof content !== 'string') {
				return;
			}

			CORE.__onElements(function (el) {
				$(el).append(content);
			});

		},

		set: function (content) {

			if (typeof content !== 'string') {
				return;
			}

			CORE.__onElements(function (el) {
				el.innerHTML = content;
			});

		},

		reset: function () {

			CORE.set('');

		},

		addEvent: function (type, callback) {
			const elements = CORE.elements;
			var i = 0;

			if (!elements || elements === null || !elements.length) {
				return false;
			}

			for (i; i < elements.length; i++) {
				elements[i].addEventListener(type, function (e) {
					callback(e, this);
				});
			}

		},

		construct: function () {
			const elements = DOC.getElementsByClassName(className);
			var i = 0;

			if (!elements || elements === null || typeof elements !== 'object' || !('length' in elements) || !elements.length) {
				return;
			}
			CORE.elements = [];

			for (i; i < elements.length; i++) {
				CORE.elements[CORE.elements.length] = elements[i];
			}

		}

	};

	CORE.construct();

	return {
		getElements: CORE.getElements,
		append: CORE.append,
		addEvent: CORE.addEvent,
		set: CORE.set,
		reset: CORE.reset
	};

};
